import { render, staticRenderFns } from "./VideoBox.vue?vue&type=template&id=fee9cace&scoped=true&"
import script from "./VideoBox.vue?vue&type=script&lang=ts&"
export * from "./VideoBox.vue?vue&type=script&lang=ts&"
import style0 from "./VideoBox.vue?vue&type=style&index=0&id=fee9cace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee9cace",
  null
  
)

export default component.exports